<template>
  <Page></Page>
</template>

<style lang="scss" src="./assets/_common/scss/_grid.scss"></style>
<style lang="scss" src="./assets/_common/scss/_mixins.scss"></style>
<style lang="scss" src="./assets/_common/scss/_universal.scss"></style>
<style lang="scss" src="./assets/_common/scss/_layout.scss"></style>
<style lang="scss" src="./assets/_common/scss/_breakpoints.scss"></style>
<style lang="scss" src="./assets/_common/scss/_ads.scss"></style>
<style lang="scss" src="./App.scss"></style>

<script>
  import { PermissionClientWrapper } from '@/services/wrapper/permissionClientWrapper'
  import { TrackingWrapper } from '@/services/wrapper/trackingWrapper'
  import { EventTrackingWrapper } from '@/services/wrapper/eventTrackingWrapper'
  import { Helper } from '@/services/helper/helper'
  import NCTTracking from '@/services/helper/NCTTracking'
  import Logger from '@/services/helper/Logger'
  import Homepage from '@/views/Homepage/Homepage'
  import Logout from '@/views/Logout/Logout'

  export default {
    name: 'App',
    components: {
      Page: window.PageConfig.site === 'll' ? Logout : Homepage
    },
    data () {
      return {
        site: window.PageConfig.site,
        urlParams: new URLSearchParams(window.location.search)
      }
    },
    methods: {
      async getPermissionScripts () {
        if (window.PageConfig.tcf === false) {
          return
        }

        let stage = window.PageConfig.stage.includes('qa') ? 'qa' : window.PageConfig.stage

        if (stage === 'dev' || stage === 'local') {
          stage = 'qa'
        } else if (stage === 'prelive') {
          stage = 'live'
        }

        const permissionClientBaseURL = '//dl.' + window.SiteInfo.brandShort + '.' + window.SiteInfo.tld + '/permission/' + stage + '/portal/v1/ppp/js/'
        const permissionClientURL = permissionClientBaseURL + 'permission-client.js'
        const permissionClientCompatURL = permissionClientBaseURL + 'permission-client-compat.js'

        try {
          await Helper.addScript(permissionClientURL)
          await Helper.addScript(permissionClientCompatURL)
          new PermissionClientWrapper()
        } catch (error) {
          console.log(error)
        }
      },
      setSiteInfo () {
        if (!window.SiteInfo) {
          window.SiteInfo = {}
        }

        window.SiteInfo.brand = process.env.VUE_APP_BRAND

        if (location.hostname !== 'localhost') {
          const regex = /\.([^.]+?)$/
          window.SiteInfo.tld = regex.exec(location.hostname)[1]
        }
        // get Top Level Domain
        if (window.SiteInfo.tld === 'lan' || location.hostname === 'localhost') {
          if (window.SiteInfo.brand === 'gmx') {
            window.SiteInfo.tld = 'net'
          } else {
            window.SiteInfo.tld = 'de'
          }
        }

        window.SiteInfo.brandShort = ''
        switch (window.SiteInfo.brand) {
          case 'webde':
            window.SiteInfo.brandShort = 'web'
            window.SiteInfo.portalName = 'webde'
            break
          case 'gmx':
            window.SiteInfo.brandShort = 'gmx'
            window.SiteInfo.portalName = 'gmx' + window.PageConfig.country
            break
          case 'einsundeins':
            window.SiteInfo.brandShort = '1und1'
            window.SiteInfo.portalName = '1und1'
            break
          default:
            window.SiteInfo.brandShort = 'localhost'
        }
      }
    },
    beforeCreate () {
      // disable the ability to kill the hp via an ad
      document.write = (str) => {
        if (window.location.href.includes('local')) {
          console.log('document.write ' + str)
        }
      }
      document.open = () => {
        if (window.location.href.includes('local')) {
          console.log('document.open')
        }
      }
      document.close = () => {
        if (window.location.href.includes('local')) {
          console.log('document.close')
        }
      }
    },
    created () {
      this.setSiteInfo()
      window.AdService = window.AdService || []

      document.addEventListener('colCountChanged', () => {
        document.querySelector('html').classList.remove('ce-available')
      })

      document.documentElement.style.setProperty('-ms-justify-grid-content', 'center')

      if (window.PageConfig.stage.includes('live') || (!window.PageConfig.stage.includes('live') && this.urlParams.get('tracking') !== 'false')) {
        new NCTTracking()
        window.Tracking = new TrackingWrapper()
        new EventTrackingWrapper()
      } else {
        console.log('tracking off')
      }
    },
    mounted () {
      if (window.PageConfig.stage.includes('live') || (!window.PageConfig.stage.includes('live') && this.urlParams.get('lazyloading') !== 'false')) {
        // adds lazyloading to all teaser images (except ads)
        const supportsLazyLoad = 'loading' in HTMLImageElement.prototype

        if (!supportsLazyLoad) {
          document.addEventListener('DOMContentLoaded', function () {
            if ('IntersectionObserver' in window) {
              const lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    const lazyImage = entry.target

                    if (lazyImage.dataset.src) {
                      lazyImage.src = lazyImage.dataset.src
                    }

                    lazyImageObserver.unobserve(lazyImage)
                  }
                })
              })

              document.querySelectorAll('img[loading="lazy"]').forEach((lazyImage) => {
                lazyImageObserver.observe(lazyImage)
              })
            }
            // Else we have a problem... no images as result
            // BUUUUT this should never ever happen, because the browser support for IntersectionObserver is way better than loading on HTMLImageElement
          })
        } else {
          document.querySelectorAll('img[loading="lazy"]').forEach((image) => {
            if (image.dataset.src) {
              image.src = image.dataset.src
            }
          })
        }
      } else {
        console.log('lazyloading off')
      }

      if (window.PageConfig.stage.includes('qa')) {
        Helper.addScript('https://s.uicdn.com/t/qa/iq/mam/purple/daq.js')
      } else if (window.PageConfig.stage.includes('dev')) {
        Helper.addScript('https://s-qa.uicdn.com/t/dev/iq/mam/purple/daq.js')
      }

      this.$nextTick().then(() => {
        window.startupPageReadyTS = new Date().getTime()
        window.siteTimeout && clearTimeout(window.siteTimeout)
        Logger.log(`%cMonitoring: Site init Duration: ${new Date().getTime() - window.startupTS}ms `, { urlParam: 'LogTimeout' })
      });

      // closure for scope
      (() => {
        const _this = this
        window.addEventListener('load', (e) => {
          if (window.PageConfig.stage !== 'live') {
            console.log(new Date().getTime() - window.startupTS + 'ms since JS start')
            console.log(new Date().getTime() - window.startupTSVue + 'ms since VueJS start')
            console.log(new Date().getTime() - window.startupPageReadyTS + 'ms since pageReady event')
          }

          if (window.PageConfig.stage.includes('live') || (!window.PageConfig.stage.includes('live') && this.urlParams.get('permissionlayer') !== 'false')) {
            _this.getPermissionScripts()
          } else {
            console.log('permissionlayer off')
          }
        })
      })()

      this.$store.watch((state) => state.pageVisible, () => { document.body.setAttribute('data-complete', 'true') })
    }
  }
</script>
